<div class="shift-details-container">
  <div class="panel-title">
    Shift {{ shift.id }}
  </div>
  <div class="panel-content">
    <div>
      {{ !!shift.vehicle.label ? shift.vehicle.label : shift.vehicle.name }}
    </div>
    @if (shift.devicesUsed !== ShiftDevices.LMU) {
      <div>
          {{ shift.driver.givenName }} {{ shift.driver.familyName }}
      </div>
    }
    <div>
      {{ shift.start | date:'MMM d h:mma' }} Start
    </div>
    <div>
      {{ shift.end | date:'MMM d h:mma' }} Finish
    </div>
    @if (shift.statusStatistics === StatisticsStatus.ERROR) {
      <div>
        <span>Statistics processing failed</span>
        <button mat-button color="warn" (click)="loadStats()">Refresh</button>
      </div>
    } @else if (shift.statusStatistics === StatisticsStatus.READY || shift.statusStatistics === StatisticsStatus.PROCESSING) {
      <div>
        <span>Processing statistics...</span>
        <button mat-button color="accent" (click)="loadStats()">Refresh</button>
      </div>
    } @else if (shift.statusStatistics === StatisticsStatus.COMPLETE) {
      <div>
        {{ getDuration() | duration }} Total Duration
      </div>
      @if (!statsLoading) {
        <div>
          {{ stats.trackLength | distance:configuration.useMetricSystem:false }} Total {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
        </div>
      }
      @if (configuration && shift.vehicleHardwareConfiguration &&
      shift.vehicleHardwareConfiguration.sensorInputs &&
      shift.vehicleHardwareConfiguration.sensorInputs.length > 0
        ) {
        @for (sensorType of HardwareConfiguration.getAggregatedSensorTypesForStatistics(shift.vehicleHardwareConfiguration.sensorInputs); track sensorType) {
          @if (sensorType === SensorType.PLOW) {
            <div>
              {{ shift.distancePlowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Plowed
            </div>
            @if (!statsLoading) {
              <div>
                {{ stats.trackLength - shift.distancePlowed | distance:configuration.useMetricSystem:false }}
                ({{ ((stats.trackLength - shift.distancePlowed) / stats.trackLength * 100).toFixed(0) || 'N/A' }} %)
                Deadhead
                {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
              </div>
            }
          } @else if (sensorType === SensorType.GRANULAR_SPREADER) {
            <div>
              {{ shift.distanceSpreadGranular | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Granular Spread
            </div>
            <div>
              {{ shift.materialUsedGranular | weight:configuration.useMetricSystem }} Granular
            </div>
          } @else if (sensorType === SensorType.LIQUID_SPREADER) {
            <div>
              {{ shift.distanceSpreadLiquid | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Liquid Spread
            </div>
            <div>
              {{ shift.materialUsedLiquid | volume:configuration.useMetricSystem }} Liquid
            </div>
          } @else if (sensorType === SensorType.MOWER) {
            <div>
              {{ shift.distanceMowed | distance:configuration.useMetricSystem }} Mowed
            </div>
          } @else if (sensorType === SensorType.SWEEPER) {
            <div>
              {{ shift.distanceSwept | distance:configuration.useMetricSystem }} Swept
            </div>
          }
        }
      }
    }
    <div>
      GPS Source: {{ getGpsSource() }}
    </div>
  </div>

  <div class="panel-title">
    Assignments
  </div>
  <div class="panel-content">
    @if (!assignments && assignmentsLoading) {
      <mat-spinner [diameter]="50"></mat-spinner>
    } @else if (!assignments && !assignmentsLoading) {
      <span>Failed to retrieve data.</span>
    } @else if (!!assignments && assignments.length === 0) {
      <span>None</span>
    } @else if (!!assignments && assignments.length > 0 && assignmentItems) {
      @for (item of assignmentItems; track item.id) {
        <!--<button mat-button [routerLink]="['assignment', assignment.id]">
          {{ assignment.routeName }}
        </button>-->
        <app-action-menu-item [input]="item"></app-action-menu-item>
      }
    }
  </div>

  <div class="panel-title">
    Inspection Forms
  </div>
  <div class="panel-content">
      @if (this.inspectionItemsLoading()) {
          <mat-spinner [diameter]="32"></mat-spinner>
      } @else {
          @if ((shift.startInspectionId || shift.endInspectionId) && inspectionItems) {
              @for (item of inspectionItems; track item.id) {
                  <app-action-menu-item [input]="item"></app-action-menu-item>
              }
          } @else {
              <span>None</span>
          }
      }
  </div>

  <div class="panel-title">
    Observations
  </div>
  <div class="panel-content">
    @if (observations && observations.length > 0 && observationItems) {
      @for (item of observationItems; track item.id) {
        <app-action-menu-item [input]="item" #itemRef [id]="'obs-'+item.id"></app-action-menu-item>
      }
    } @else {
      <span>None</span>
    }
  </div>

</div>
